
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
import React from 'react';
import { PhoneMockup } from '../../HeroAnimation';
import { Wallet, Store, Bell, FileText, Fingerprint, CreditCard } from 'lucide-react';

export const GhostWalletMobile = () => (
  <div className="space-y-12">
    <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
            <p className="text-lg text-stone-600 dark:text-stone-300 leading-relaxed font-medium mb-8">
                GhostWallet OS extends its powerful features to a dedicated mobile application, providing a seamless experience for managing your finances on the go.
            </p>
            <div className="space-y-6">
                {[
                    { icon: Wallet, title: "Unified Wallet", desc: "Manage assets across Solana & Sui." },
                    { icon: CreditCard, title: "Card Controls", desc: "Freeze, unfreeze, and manage limits for your Titanium card." },
                    { icon: Store, title: "Mobile POS", desc: "Run your Point-of-Sale from your phone." },
                    { icon: Bell, title: "Real-time Alerts", desc: "Instant push notifications for payments." },
                    { icon: FileText, title: "History", desc: "Access complete transaction ledger." },
                    { icon: Fingerprint, title: "Biometric Security", desc: "Face ID & Fingerprint authorization." }
                ].map((item, i) => (
                    <div key={i} className="flex items-center gap-4 p-3 rounded-lg hover:bg-stone-50 dark:hover:bg-white/5 transition-colors">
                        <div className="w-10 h-10 rounded-full bg-stone-100 dark:bg-white/10 flex items-center justify-center text-stone-900 dark:text-white flex-shrink-0">
                            <item.icon size={18} />
                        </div>
                        <div>
                            <h5 className="font-bold text-stone-900 dark:text-white text-base">{item.title}</h5>
                            <p className="text-sm text-stone-500 dark:text-stone-400">{item.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
        <div className="flex justify-center scale-90 lg:scale-100 origin-top">
            <PhoneMockup />
        </div>
    </div>
  </div>
);
